var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndustryChemicals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-1024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-details",
    transform: "translate(-619.000000, -131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/industry-chemicals",
    transform: "translate(619.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#07575B",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "florence-flask",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.422885,10.675 L7.64329848,4.735 L7.64329848,1.6 C7.97195818,1.6 8.19106464,1.38 8.19106464,1.05 C8.19106464,0.72 7.97195818,0.5 7.64329848,0.5 L4.35670152,0.5 C4.02804182,0.5 3.80893536,0.72 3.80893536,1.05 C3.80893536,1.38 4.02804182,1.6 4.35670152,1.6 L4.35670152,4.735 L0.577115015,10.675 C0.358008551,11.06 0.631891631,11.5 1.07010456,11.5 L10.9298954,11.5 C11.3681084,11.5 11.6419914,11.06 11.422885,10.675 L11.422885,10.675 Z M8.19106464,7.65 L3.86371198,7.65 L5.45223384,5.065 L5.45223384,1.6 L6.54776616,1.6 L6.54776616,5.065 L8.19106464,7.65 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryChemicals);
export default __webpack_public_path__ + "static/media/industry-chemicals.0083173b.svg";
export { ForwardRef as ReactComponent };